var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAlert = function SvgAlert(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 36,
    viewBox: "0 0 43 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4095 2.52962C19.7831 0.299651 23.2169 0.299654 24.5905 2.52962L41.588 30.1254C42.9616 32.3554 41.2446 35.1429 38.4975 35.1429H4.50245C1.75537 35.1429 0.0384518 32.3554 1.41199 30.1254L18.4095 2.52962Z",
    stroke: "#FE2828",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2287 22.5103H21.7714C21.9933 22.5103 22.2153 22.2978 22.24 22.0853L22.9553 14.6221V11.6475C22.9553 11.3819 22.7333 11.1429 22.4867 11.1429H20.5134C20.2667 11.1429 20.0447 11.3819 20.0447 11.6475V14.6753L20.76 22.0853C20.7847 22.2978 21.0067 22.5103 21.2287 22.5103ZM19.7858 27.3103C19.7858 28.3195 20.5751 29.1429 21.4877 29.1429C22.4497 29.1429 23.2143 28.3195 23.2143 27.3103C23.2143 26.2744 22.4497 25.4511 21.4877 25.4511C20.5751 25.4511 19.7858 26.2744 19.7858 27.3103Z",
    fill: "#FE2828"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAlert, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/alert.5d9ffd72.svg";
export { ForwardRef as ReactComponent };